import { render, staticRenderFns } from "./sence.vue?vue&type=template&id=c3377de8&scoped=true&"
import script from "./sence.vue?vue&type=script&lang=js&"
export * from "./sence.vue?vue&type=script&lang=js&"
import style0 from "./sence.vue?vue&type=style&index=0&id=c3377de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3377de8",
  null
  
)

export default component.exports